module.exports = __webpack_public_path__ + "578b3fe07e3c83dc947429bcb337fee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/6.jpg
// module id = 437
// module chunks = 0 2